import { UNSELECTED_CHECKBOX_VALUE } from 'constants/general';

export function getTotalDebtAmount(debtAccounts = {}, accounts) {
  if (!debtAccounts.values) return 0;
  let total = 0;
  Object.entries(debtAccounts.values).forEach(([key, value]) => {
    const foundAccount = accounts.some((account) => account.id === key);
    if (foundAccount) {
      total = total + (!value || value === UNSELECTED_CHECKBOX_VALUE ? 0 : parseFloat(value));
    }
  });
  if (debtAccounts.values.externalAmount) {
    total =
      total +
      (debtAccounts.values.externalAmount &&
      debtAccounts.values.externalAmount !== UNSELECTED_CHECKBOX_VALUE
        ? parseFloat(debtAccounts.values.externalAmount)
        : 0);
  }
  return total > 0 ? total.toFixed(2) : total;
}
